import TuneIcon from "@mui/icons-material/Tune";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import IconButton from "@mui/material/IconButton";
import React from "react";
import { useNavigate } from "react-router";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";

import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

export default function ButtonMenuSettings({ type, id, color }) {
	const [anchorEl, setAnchorEl] = React.useState(null);
	const navigate = useNavigate();
	const open = Boolean(anchorEl);
	const handleClick = (event) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = (value) => {
		setAnchorEl(null);
		navigate(value);
	};

	return (
		<>
			<IconButton
				sx={{ fontSize: 10 }}
				onClick={handleClick}
				color={color ? color : "secondary"}
			>
				<TuneIcon />
			</IconButton>
			<Menu
				anchorEl={anchorEl}
				open={open}
				onClose={() => setAnchorEl(null)}
				sx={{ py: 0, "& .MuiList-root": { p: 0 } }}
			>
				<MenuList
					dense
					disablePadding
				>
					<MenuItem
						onClick={() =>
							handleClose("./modifier_" + type + "/" + id)
						}
					>
						<ListItemIcon sx={{ color: "info.main" }}>
							<EditIcon />
						</ListItemIcon>
						<ListItemText sx={{ color: "info.main" }}>
							Modifier {type}
						</ListItemText>
					</MenuItem>

					<MenuItem
						onClick={() =>
							handleClose("./supprimer_" + type + "/" + id)
						}
					>
						<ListItemIcon sx={{ color: "error.main" }}>
							<DeleteIcon />
						</ListItemIcon>
						<ListItemText sx={{ color: "error.main" }}>
							Supprimer {type}
						</ListItemText>
					</MenuItem>
				</MenuList>
			</Menu>
		</>
	);
}
